import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Response_HPFacilities } from '../../../../../constants/APIs';

export default class HolidayParkFacilities extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Response_HPFacilities} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
